// Animation frame definitions shared by all Golem types
const GOLEM_ANIMS = [
  { suffix: "idle",                 end: 11, repeat: -1 },
  { suffix: "idle_blinking",        end: 11, repeat: -1 },
  { suffix: "walking",              end: 15, repeat: -1 },
  { suffix: "running",              end: 7,  repeat: -1 },
  { suffix: "slashing",             end: 7,  repeat: 0 },
  { suffix: "hurt",                 end: 7,  repeat: 0 },
  { suffix: "dying",                end: 9,  repeat: 0 },
];
export const ENEMY_TYPES = {
  golem_1: {
    prefix: "golem_1",
    dir: "assets/characters/enemies/Golem_1_spritesheets/",
    originX: 0.4933,
    originY: 0.8657,
    w: 36,
    h: 56,
    hp: 50,
    anims: GOLEM_ANIMS,
    behavior: "melee",
    speed: 0.95,
    chaseSpeed: 1.5,
    aggroRange: 260,
    attackRange: 40,
    attackDamage: 10,
    attackDuration: 400,
    attackCooldownBase: 700,
    attackCooldownJitter: 180,
    patrolDistance: 200,
    projectile: null,
  },
  golem_2: {
    prefix: "golem_2",
    dir: "assets/characters/enemies/Golem_2_spritesheets/",
    originX: 0.519,
    originY: 0.8955,
    w: 36,
    h: 56,
    hp: 50,
    anims: GOLEM_ANIMS,
    behavior: "melee",
    speed: 0.9,
    chaseSpeed: 1.35,
    aggroRange: 250,
    attackRange: 45,
    attackDamage: 15,
    attackDuration: 450,
    attackCooldownBase: 740,
    attackCooldownJitter: 180,
    patrolDistance: 160,
    projectile: null,
  },
  golem_3: {
    prefix: "golem_3",
    dir: "assets/characters/enemies/Golem_3_spritesheets/",
    originX: 0.4899,
    originY: 0.904,
    w: 36,
    h: 56,
    hp: 50,
    anims: GOLEM_ANIMS,
    behavior: "melee",
    speed: 0.85,
    chaseSpeed: 1.25,
    aggroRange: 240,
    attackRange: 50,
    attackDamage: 20,
    attackDuration: 500,
    attackCooldownBase: 780,
    attackCooldownJitter: 180,
    patrolDistance: 140,
    projectile: null,
  },
};
